import * as React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import messengerExamples from "../../assets/images/messenger-examples.jpg"
import messengerReserveBubble from "../../assets/images/messenger-reserve-bubble.jpg"
import messengerSourceVehicleBubbles from "../../assets/images/messenger-source-vehicle-bubbles.jpg"
import messengerForwardBubbles from "../../assets/images/messenger-forward-bubbles.jpg"
import ContactBanner from "../../components/ContactBanner"
import Feature from "../../components/Feature"

export default () => (
  <Layout fixedHeader={false}>
    <SEO title="Automotive Messenger" />
    <div className="container mb-4">
      <div className="heading">
        <h1>Dealer 9000 Messenger</h1>
        <h4 className="secondary">
          Increase leads and make sales 24/7 with our pioneering customer
          messenger.
        </h4>
      </div>
      <Feature>
        <div className="text-image">
          <LazyLoadImage
            src={messengerExamples}
            alt="Automotive Messenger"
            className="media"
          />
          <div className="content">
            <h2>Your Online Salesperson</h2>
            <p>
              You can think of your dealer website as your online showroom, it
              will most likely have 100’s of visitors a day browsing your stock.
              The difference between the two is your website will have more
              visitors but no salesperson. Imagine how many sales would be lost
              if your sales team didn’t approach customers, well this is what is
              happening on your website daily.
            </p>
            <p>
              Messenger solves this problem, it reaches out to your website
              visitors based on their behaviour and will attempt to convert
              them.
            </p>
          </div>
        </div>
      </Feature>
      <Feature>
        <div className="text-image">
          <div className="content">
            <h2>Pushes Sales</h2>
            <p>
              When website visitors are browsing your vehicles Messenger will
              ask them if they'd like to leave a deposit and handles the payment
              for you.
            </p>
          </div>
          <LazyLoadImage
            src={messengerReserveBubble}
            alt="Automotive Reserve Messenger"
            className="media"
          />
        </div>
      </Feature>
      <Feature>
        <div className="text-image">
          <LazyLoadImage
            src={messengerSourceVehicleBubbles}
            alt="Automotive Source Vehicle Messenger"
            className="media"
          />
          <div className="content">
            <h2>Helps Visitors</h2>
            <p>
              Many website visitors won’t be able to find a vehicle that matches
              their requirements but would like to buy from you. Messenger
              detects when a visitor is having trouble finding a vehicle and
              asks them to describe their ideal vehicle. Leads generated are
              sent directly to you with the prospects requirements and contact
              information.
            </p>
          </div>
        </div>
      </Feature>
      <Feature>
        <div className="text-image">
          <div className="content">
            <h2>Forwards Questions</h2>
            <p>
              Getting prospects on the phone talking to a human is really
              beneficial. Messenger forwards all questions to you with all of
              the contact information you need such as name and phone number.
            </p>
          </div>
          <LazyLoadImage
            src={messengerForwardBubbles}
            alt="Automotive Forward Messenger"
            className="media"
          />
        </div>
      </Feature>
    </div>
    <ContactBanner />
  </Layout>
)
